export const onPrint = () => {
  window.print();
}